import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/quality-assurance/investigations-capa-management")({
  beforeLoad: () => { throw redirect({ to: "/en/services/quality-assurance/quality-compliance-remediation-capa", statusCode: 301 }); },
});
